export const getErrorMessage = (payload: unknown): string => {
    if (payload instanceof Error) {
        return payload.message;
    }
    if (typeof payload === "string") {
        return payload;
    }
    if (payload && (payload as { error: string }).error) {
        return (payload as { error: string }).error;
    }
    if (payload && (payload as { status: number; data: { message: string } }).data) {
        const { data } = payload as { status: number; data: { message: string } };
        return `${data.message || "An unexpected error occurred"}`;
    }
    return "An unexpected error occurred";
};
